import timeUtils from '@/utils/time.utils'
import css from './weekViewCalendar.module.css'
import React, { memo } from 'react'
import { useRecoilValue } from 'recoil'
import { IMaintenanceEvent, IMaintenanceEventFilters } from '../calendar.types'
import equipmentSelectors from '@/pages/Equipment/equipment.selectors'
import EventCell from './components/EventCell'
import SkeletonEventCell from './components/SkeletonEventCell'

interface IProps {
  selectedDates: {
    date_lte: Date
    date_gte: Date
  }

  isLoaded: boolean
  onClick: (event: IMaintenanceEvent) => void
  events: IMaintenanceEvent[]
  selectedDay: Date
}

const CalendarWeekView = (props: IProps) => {
  const equipmentMap = useRecoilValue(equipmentSelectors.getEquipmentMap)

  const getWeekInterval = (dates: IMaintenanceEventFilters) => {
    return timeUtils.eachDayOfInterval({ start: dates.date_gte, end: dates.date_lte })
  }

  const renderEventCells = (date: Date) => {
    const filteredEvents = props.events.filter((item) => timeUtils.isSameDay(new Date(item.ts), date))

    return filteredEvents.map((event) => (
      <EventCell
        key={event.id}
        event={event}
        equipmentLocation={equipmentMap[event.metadata.equipmentId]?.location}
        onClick={() => props.onClick(event)}
      />
    ))
  }

  const renderSkeletonEventCells = () => {
    return (
      <>
        <SkeletonEventCell />
        <SkeletonEventCell />
      </>
    )
  }

  const renderCol = () => {
    const cells = getWeekInterval(props.selectedDates)
    return cells.map((item, index) => (
      <div
        key={item.getTime()}
        className={css.cell}
        data-selected-day={props.selectedDay && timeUtils.isSameDay(props.selectedDay, cells[index])}
      >
        {props.isLoaded ? renderEventCells(item) : renderSkeletonEventCells()}
      </div>
    ))
  }

  const renderCalendarHeader = () => {
    const cells = getWeekInterval(props.selectedDates)
    return Array.from({ length: 7 }).map((_, index) => (
      <div
        className={css.cellHeaderContainer}
        style={{ paddingLeft: '8px' }}
        key={index}
        data-selected-day={props.selectedDay && timeUtils.isSameDay(props.selectedDay, cells[index])}
      >
        <span className={css.cellDayText} data-current-day={timeUtils.isToday(cells[index])}>
          {timeUtils.formatDate(cells[index], 'EEEEEE, dd.MM')}
        </span>
      </div>
    ))
  }

  return (
    <div className={css.container}>
      {renderCalendarHeader()}
      {renderCol()}
    </div>
  )
}

export default memo(CalendarWeekView)
